import React, { useContext, useState } from "react";
import { RicosContext } from "./../../../ricos-context/index.js";
import {
  getIsModalOpen,
  useModalService,
  useModalState
} from "./../../../ricos-modals/modal-service-provider.js";
import { DividerData_Width } from "./../../../ricos-schema/legacy/wix/rich_content/v1/index.js";
import { DropdownButton } from "./../../../_shared/dropdown-button.js";
import { NodeAlignmentDropdown } from "./../../../_shared/node-alignment-dropdown/node-alignment-dropdown.js";
import { alignmentMap } from "./dividerButtonsData.js";
const getDefaultAlignment = (langDir) => {
  return langDir === "rtl" ? "RIGHT" : "LEFT";
};
const DividerAlignmentButton = ({ toolbarItem, dataHook, id }) => {
  const { t, languageDir, isMobile } = useContext(RicosContext) || {};
  const modalService = useModalService();
  const isModalOpen = useModalState(getIsModalOpen(id));
  const node = toolbarItem.attributes.selectedNode;
  const [referenceElement, setReferenceElement] = useState(null);
  const getSelectedAlignment = () => node?.attrs?.alignment || getDefaultAlignment(languageDir);
  const selectedAlignment = getSelectedAlignment();
  const SelectedAlignmentIcon = alignmentMap[selectedAlignment];
  const isButtonDisabled = node?.attrs?.width === DividerData_Width.LARGE;
  const closeModal = () => modalService.closeModal(id);
  const onAlignmentClick = (alignment) => {
    toolbarItem.commands?.click({ value: alignment });
    closeModal();
  };
  const onClick = () => {
    modalService.isModalOpen(id) ? closeModal() : modalService.openModal({
      id,
      Component: NodeAlignmentDropdown,
      componentProps: {
        modalId: id,
        options: ["LEFT", "CENTER", "RIGHT"],
        getSelectedAlignment,
        onClick: onAlignmentClick
      },
      layout: isMobile ? "drawer" : "floating",
      positioning: { referenceElement, placement: "bottom" }
    });
  };
  return /* @__PURE__ */ React.createElement(
    DropdownButton,
    {
      dataHook,
      active: isModalOpen,
      onClick,
      disabled: isButtonDisabled,
      ref: setReferenceElement,
      icon: SelectedAlignmentIcon,
      tooltip: t("TextAlignmentButton_Tooltip"),
      tabIndex: toolbarItem.presentation.tabIndex
    }
  );
};
export {
  DividerAlignmentButton
};
//# sourceMappingURL=DividerAlignmentButton.js.map
